import React from 'react';
import { Menu } from 'antd';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

const SidebarItem = React.memo(function SidebarItem({
  id,
  className,
  icon,
  href,
  text,
  extra,
  onClick,
  ...rest
}) {
  const itemContent = (
    <>
      {icon ? icon : <div />}
      <span title={text} className="sidebar__nav-item-text">
        {text}
      </span>
    </>
  );

  return (
    <Menu.Item
      key={id}
      className={cn('sidebar__nav-item', className)}
      onClick={onClick}
      {...rest}
    >
      {href ? (
        <NavLink className="sidebar__nav-link" to={href}>
          {itemContent}
        </NavLink>
      ) : (
        itemContent
      )}
      {extra}
    </Menu.Item>
  );
});

SidebarItem.whyDidYouRender = false;

export default SidebarItem;
